import * as Yup from "yup";

const salesSchema = {};

salesSchema.validateAdd = (values) => {
  const isZeroValueEnabled = values?.is_zero_value == "1";

  let schema = Yup.object({
    cust_id: Yup.string().required("Customer Name is Required."),
    challan_date: Yup.string().required("Challan Date is Required."),
    // inv_no: Yup.string().required("Invoice No is Required.").matches(/^[aA-z0-9Z-\s\/\:]+$/, `Invoice should be alphanumeric`),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          // requested_qty: Yup.number()
          //   .typeError("Item Reqd. Qty must be number")
          //   .transform((_, v) => (v == "" ? null : Number(v)))
          //   // .min(1, "Item Reqd. Qty must be greater than or equal to 1")
          //   .moreThan(0, "Item Reqd. Qty must be greater than 0")
          //   .nullable()
          //   .required("Item Reqd. Qty field is required")
          //   .max(99999999.99, "Item Reqd. Qty cannot exceed 8 Digits"),
          requested_qty: Yup.number()
            .typeError("Item Reqd. Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .when("$isZeroValueEnabled", {
              is: true,
              then: (schema) =>
                schema.min(0, "Item Reqd. Qty must be 0 or greater").nullable(),
              otherwise: (schema) =>
                schema
                  .moreThan(0, "Item Reqd. Qty must be greater than 0")
                  .required("Item Reqd. Qty field is required"),
            })
            .max(99999999.99, "Item Reqd. Qty cannot exceed 8 Digits"),
          // rate: Yup.number()
          //   .typeError("Item Rate must be number")
          //   .transform((_, v) => (v == "" ? null : Number(v)))
          //   .min(0, "Item Rate must be greater than or equal to 0")
          //   .nullable()
          //   .required("Item Rate field is required")
          //   .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),
          rate: Yup.number()
            .typeError("Item Rate must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .test(
              "rate-validation",
              "Item Rate field is required",
              function (value) {
                if (isZeroValueEnabled) {
                  return value !== null && value !== undefined && value >= 0;
                }
                return value !== null && value !== undefined && value > 0;
              }
            )
            .test(
              "rate-zero-validation",
              "Item Rate must be greater than 0",
              function (value) {
                if (
                  !isZeroValueEnabled &&
                  value !== null &&
                  value !== undefined &&
                  value <= 0
                ) {
                  return false;
                }
                return true;
              }
            )
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),

          amount: Yup.string().required("Item Amount is Required"),
          disc: Yup.string().required("Item Discount is Required"),
          godown_id: Yup.string().required("Item Godown Name is Required"),
        })
      )
      .min(1, "Invalid Product Details."),
  });

  // return schema.validate(values, { abortEarly: false }).catch((err) => err);
  return schema
    .validate(values, {
      abortEarly: false,
      context: { isZeroValueEnabled: values.is_zero_value == "1" },
    })
    .catch((err) => err);
};

salesSchema.validateEdit = (values) => {
  let schema = Yup.object({
    cust_id: Yup.string().required("Customer Name is Required."),
    challan_date: Yup.string().required("Challan Date is Required."),
    // inv_no: Yup.string().required("Invoice No is Required.").matches(/^[aA-z0-9Z-\s\/\:]+$/, `Invoice should be alphanumeric`),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          requested_qty: Yup.number()
            .typeError("Item Reqd. Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            // .min(1, "Item Reqd. Qty must be greater than or equal to 1")
            .moreThan(0, "Item Reqd. Qty must be greater than 0")
            .nullable()
            .required("Item Reqd. Qty field is required")
            .max(99999999.99, "Item Reqd. Qty cannot exceed 8 Digits"),
          // rate: Yup.number()
          //   .typeError("Item Rate must be number")
          //   .transform((_, v) => (v == "" ? null : Number(v)))
          //   .min(0, "Item Rate must be greater than or equal to 0")
          //   .nullable()
          //   .required("Item Rate field is required")
          //   .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),
          rate: Yup.number()
            .typeError("Item Rate must be number")
            .transform((_, v) => (v === "" ? null : Number(v)))
            .nullable()
            .required("Item Rate field is required")
            .moreThan(0, "Item Rate must be greater than 0")
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),

          amount: Yup.string().required("Item Amount is Required"),
          disc: Yup.string().required("Item Discount is Required"),
          godown_id: Yup.string().required("Item Godown Name is Required"),
        })
      )
      .min(1, "Invalid Product Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

export default salesSchema;
